import React, { useEffect } from 'react';
import classes from '../classes.module.scss';
import env from '../../../config/variables';

const { GOOGLE_CLIENT_ID } = env;

export const googleLoginScript = () => <script id="googleLoginBtnScript" src="https://accounts.google.com/gsi/client" async defer />;

function GoogleLoginBtn({ googleConfig, googleCallback }) {
  const googleLoginCallback = (response) => {
    googleCallback(response.credential);
  };

  useEffect(() => {
    if (googleConfig) {
      googleConfig.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: googleLoginCallback
      });
      googleConfig.accounts.id.renderButton(
        document.getElementById('google_button_holder'),
        {
          theme: 'outline',
          size: 'large',
          text: 'signin',
          width: 150
        }
      );
    }
  }, [googleConfig]);

  return (
    <div
      className={ classes.googleButton }
      id="google_button_holder"
    />
  );
}

export default GoogleLoginBtn;
